import { useTranslation } from "react-i18next";
import emptyImage from "../../../media/images/emptystate.svg";
export default function EmptyData({emptyText}) {
    const {t} = useTranslation();
    return (
        <>
            <div className="relative flex flex-col justify-center items-center pt-2 mt-3">
                <img src={emptyImage} alt="empty" className="" />
                <p className="mt-2 text-slate-500">{emptyText ? t(emptyText) : t("No data avilable")}</p>
            </div>
        </>
    )
}